import { useContext } from "react";
import State from "../../../../../../context";
import ReportPdfContentHolder from "../../../../pdf/template/ReportPdfContentHolder";
import SectionMilestonesQuestionnaire from "./components/SectionMilestonesQuestionnaire";
import SectionPerspectiveCoupleResults from "./components/SectionPerspectiveCoupleResults";
import SectionPerspectiveIndividualResults from "./components/SectionPerspectiveIndividualResults";
import SectionPrioritiesCoupleResults from "./components/SectionPrioritiesCoupleResults";
import SectionWorkspace from "./components/SectionWorkspace";

import StylesContainer from "./style";

const PageDashboard = () => {
  const [state] = useContext(State);

  const saveMilestonesQuestions = milestonesQuestions => {
    state.setKeyValue("loading", true);

    state
      .setPreference({
        quizProgressState: state
          .getPreferenceValue("quizProgressState")
          .map(it => {
            if (it.type === "milestones") {
              return {
                ...it,
                status: "started",
                visible: true,
              };
            } else {
              return it;
            }
          }),
        milestonesQuestions,
      })
      .then(() => {
        state.showSuccess("Milestones has been saved.");
        state.setKeyValue("viewMilestonesQuestionnaire", false);
      })
      .catch(state.showError)
      .finally(() => state.setKeyValue("loading", false));
  };

  return (
    <StylesContainer>
      {state.viewPerspectiveIndividualResults ? (
        <SectionPerspectiveIndividualResults />
      ) : state.viewPerspectiveCoupleResults ? (
        <SectionPerspectiveCoupleResults />
      ) : state.viewPrioritiesCoupleResults ? (
        <SectionPrioritiesCoupleResults />
      ) : state.viewMilestonesQuestionnaire ? (
        <SectionMilestonesQuestionnaire
          closeMilestonesView={() =>
            state.setKeyValue("viewMilestonesQuestionnaire", false)
          }
          saveMilestonesQuestions={saveMilestonesQuestions}
          state={state}
        />
      ) : (
        <SectionWorkspace />
      )}

      <ReportPdfContentHolder />
    </StylesContainer>
  );
};

export default PageDashboard;
